import { unwrapResult } from '@reduxjs/toolkit';
import { SeedBatch } from 'constants/interface';
import { useEffect, useState } from 'react';
import { getProductionItemAvailableSeedBatchesAction } from 'state/slices/productionItem';
import { useDispatch } from './store';

interface AvailableSeedBatchesState {
  batches?: SeedBatch[]
  isLoading: boolean
}

export const useAvailableSeedBatches = (
  productionItemId: string,
  shouldTrigger: boolean,
): AvailableSeedBatchesState => {
  const dispatch = useDispatch();
  const [isLoading, setLoading] = useState(false);
  const [seedBatches, setSeedBatches] = useState<SeedBatch[]>();
  useEffect(() => {
    if (productionItemId && shouldTrigger) {
      (async () => {
        setLoading(true);
        const result = await dispatch(getProductionItemAvailableSeedBatchesAction({
          productionItemId,
        }));

        setLoading(false);
        const seedBatchResult = unwrapResult(result);

        setSeedBatches(seedBatchResult);
      })();
    }
  }, [
    productionItemId,
    shouldTrigger,
    setLoading,
    setSeedBatches,
    dispatch,
  ]);

  return {
    batches: seedBatches,
    isLoading,
  };
};
